import { Store } from 'reducers/rootReducer';

export type State = {
  confirmApplicationWithdraw: boolean;
};

const initialState: State = {
  confirmApplicationWithdraw: false
};

// Actions
const CONFIRM_APPLICATION_WITHDRAW = 'app/withdrawAppScoresModal/CONFIRM_APPLICATION_WITHDRAW';

// Reducer
type Action =
  | {
      type: typeof CONFIRM_APPLICATION_WITHDRAW;
      payload: boolean;
    };

export default function reducer(state = initialState, action: Action): State {
  switch (action.type) {
    case CONFIRM_APPLICATION_WITHDRAW:
      return {
        ...state,
        confirmApplicationWithdraw: action.payload,
      };
    default:
      return state;
  }
}

// Action creators
export const setConfirmApplicationWithdraw = (payload: boolean) => ({
  type: CONFIRM_APPLICATION_WITHDRAW,
  payload,
});

// Selectors
export const selectConfirmApplicationWithdraw = (app: Store) => app.withdrawAppScoresModal.confirmApplicationWithdraw;
